var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation / Lock close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.03845C9.51472 3.03845 7.5 5.05317 7.5 7.53845V9H6C4.89543 9 4 9.89543 4 11V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V11C20 9.89543 19.1046 9 18 9H16.5V7.53845C16.5 5.05317 14.4853 3.03845 12 3.03845ZM15.5 9V7.53845C15.5 5.60546 13.933 4.03845 12 4.03845C10.067 4.03845 8.5 5.60545 8.5 7.53845V9H15.5ZM19 11C19 10.4477 18.5523 10 18 10H6C5.44772 10 5 10.4477 5 11V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V11ZM12 13.5C12.2761 13.5 12.5 13.7239 12.5 14V17C12.5 17.2761 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.2761 11.5 17V14C11.5 13.7239 11.7239 13.5 12 13.5Z",
    fill: "#252129"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClose);
export default __webpack_public_path__ + "static/media/LockClose.d0a93f2c62c14e560c648948f847b68c.svg";
export { ForwardRef as ReactComponent };